import { FrontendFilter, isPresenceOp } from "../../Dashboard/types";

// Whether the clause is EXCLUDING: the `negate` flag on a value clause.
// "Has a value" is its own presence row, not an exclusion (#13172), and a
// presence clause never excludes even when a hand-built URL carries the flag
// (the backend refuses it there, and the chip strip ignores it the same way).
// One predicate, so the pill, the facet header's "· excluded" state and the
// chips never disagree about it.
export const isExcluding = (filter: FrontendFilter): boolean =>
  filter.negate === true && !isPresenceOp(filter.op);

export const isFilterEmpty = (filter: FrontendFilter): boolean => {
  // A presence clause (#11243) is complete the moment its op is set — the op
  // carries the whole meaning and there is no value to wait for. Without this
  // it reads as a half-filled row: no chip, no count badge, and the panel
  // discards it on collapse.
  if (isPresenceOp(filter.op)) return false;
  if (filter.value === undefined || filter.value === null) return true;
  // An "in" filter with an empty array is effectively no filter
  if (
    (filter.op === "in" || filter.op === "ref_kind_in") &&
    Array.isArray(filter.value)
  ) {
    return filter.value.length === 0;
  }
  // A "between" filter with both bounds empty is effectively no filter
  if (filter.op === "between" && Array.isArray(filter.value)) {
    const [lo, hi] = filter.value;
    return (
      (lo === null || lo === undefined) && (hi === null || hi === undefined)
    );
  }
  return false;
};

/** The applied-filter count every badge shows (#11742 round 5, review
 *  L6): one derivation for the rail badge and the chip row's phone
 *  Filters button, so the two can never disagree. */
export function countAppliedFilters(filters: FrontendFilter[]): number {
  return filters.filter((filter) => !isFilterEmpty(filter)).length;
}
